import styles from './ProductCardDiscountInfos.module.scss';
import React, { useState } from 'react';
import { useDialogStore } from '@ariakit/react';
import { Content, Modal, IconText } from '@wienenergiegithub/ui-next';
import PropTypes from 'prop-types';

const ProductCardDiscountInfo = ({
  buttonText,
  iconTyp,
  infoModalContent,
  link,
  subtext,
  titel,
}) => {
  const [open, setOpen] = useState(false);
  const dialog = useDialogStore({ open, setOpen });
  const linkProps = link ? { to: link, target: '_blank' } : null;
  const text = link && buttonText ? buttonText : 'Mehr erfahren';

  const hasInfoIconButton = !!infoModalContent?.length > 0;

  const toggleInfoButton = () => {
    if (hasInfoIconButton) {
      setOpen(!open);
    }
  };

  return (
    <>
      <IconText
        align="center"
        glyph={iconTyp}
        hasBorder
        hasInfoIconButton={hasInfoIconButton}
        heading={titel}
        iconTheme="green"
        infoButton={toggleInfoButton}
        linkProps={linkProps}
        linkText={text}
        text={subtext}
        variant="inline"
      />
      <Modal header="Rabattinformation" store={dialog} theme="default">
        <Content as="div" className={styles.modal} noSpacing withParser>
          {infoModalContent}
        </Content>
      </Modal>
    </>
  );
};

ProductCardDiscountInfo.propTypes = {
  buttonText: PropTypes.string,
  iconTyp: PropTypes.string,
  infoModalContent: PropTypes.string,
  link: PropTypes.string,
  subtext: PropTypes.string,
  titel: PropTypes.string,
};

const ProductCardDiscountInfos = ({ aktionInfoBoxes }) =>
  aktionInfoBoxes?.map(
    (
      {
        button_text_website,
        button_text,
        icon_typ,
        info_icon_website,
        info_icon,
        link_website,
        link,
        subtext_website,
        subtext,
        titel_website,
        titel,
      },
      index,
    ) => (
      <ProductCardDiscountInfo
        buttonText={button_text_website || button_text || 'Mehr erfahren'}
        iconTyp={icon_typ}
        infoModalContent={info_icon_website || info_icon}
        // eslint-disable-next-line react/no-array-index-key
        key={`${titel_website}-${index}`}
        link={link_website || link}
        subtext={subtext_website || subtext}
        titel={titel_website || titel}
      />
    ),
  );

ProductCardDiscountInfos.propTypes = {
  aktionInfoBoxes: PropTypes.arrayOf(
    PropTypes.shape({
      button_text_website: PropTypes.string,
      button_text: PropTypes.string,
      icon_typ: PropTypes.string,
      info_icon_website: PropTypes.string,
      info_icon: PropTypes.string,
      link_website: PropTypes.string,
      link: PropTypes.string,
      subtext_website: PropTypes.string,
      subtext: PropTypes.string,
      titel_website: PropTypes.string,
      titel: PropTypes.string,
    }),
  ),
};

export default ProductCardDiscountInfos;
